import { render } from "./Item_Location.vue?vue&type=template&id=45da5bfe"
import script from "./Item_Location.vue?vue&type=script&lang=js"
export * from "./Item_Location.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__